import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Navbar from "./components/NavigationBar";
import Header from "./components/Header";
import Home from "./components/Home";
import About from "./components/About";
import OurEvent from "./components/OurEvent";
import Gallery from "./components/Gallery";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import DetailsNews from "./components/DetailsNews";
import AdminHeader from "./components/Admin/AdminHeader";
import DashBoard from "./components/Admin/DashBoard";
import Menu from "./components/Menu";
import CommunityOutReach from "./components/CommunityOutReach";
import StudyandResearchcenter from "./components/StudyandResearchcenter";
import AdminLogin from "./components/Admin/AdminLogin";
import LatestNews from "./components/Admin/LatestNews";
import MostPopularNews from "./components/Admin/MostPopularNews";
import CommunityOutreach from "./components/Admin/CommunityOutreach";
import StudyResearchCenter from "./components/Admin/StudyResearchCenter";
import Campaign from "./components/Admin/Campaign";
import InNews from "./components/Admin/InNews";
import GalleryAdmin from "./components/Admin/GalleryAdmin";
import AboutusAdmin from "./components/Admin/AboutusAdmin";
import ContactUsAdmin from "./components/Admin/ContactUsAdmin";
import MostpopulerDetails from "./components/MostpopulerDetails";
import CommunityOutreachDetails from "./components/CommunityOutreachDetails";
import StudyandResearchDetails from "./components/StudyandResearchDetails";
import CampaignDetails from "./components/CampaignDetails";
import MembershipList from "./components/Admin/MembershipList";
import Whatsapp from "./components/Whatsapp";
import SocialMedialLinks from "./components/Admin/SocialMedialLinks";
import ContactDetails from "./components/Admin/ContactDetails";
import Termsandconditions from "./components/Termsandconditions";
import Privacypolicy from "./components/Privacypolicy";
import PaymentSuccess from "./components/PaymentSuccess";
import JoinUs from "./components/JoinUs";
import DonateUs from "./components/DonateUs";
import SocialMediaLink from "./components/SocialMediaLink";
import CampaignPage from "./components/CampaignPage";
import DonorList from "./components/Admin/DonorList";
import Receipt from "./components/Receipt";
import RecentNews from "./components/RecentNews";
import MostPopularNewsDetails from "./components/MostPopularNewsDetails";

const App = () => {
  return (
    <div>
      <BrowserRouter>
        <div
          className=""
          style={{
            position: "fixed",
            top: "30%",
            right: "0",
            zIndex: "1000",
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            padding: "10px",
            backgroundColor: "white",
            borderRadius: "10px",
          }}
        >
          <SocialMediaLink />
        </div>
        <div></div>
        <Routes>
          <Route
            element={
              <>
                {/* <Header /> */}
                <Navbar />
                <Home />
                <Whatsapp />
                <Footer />
              </>
            }
            path="/"
          />

          <Route
            element={
              <>
                {" "}
                {/* <Header /> */}
                <Navbar />
                <JoinUs />
                <Whatsapp />
                <Footer />
              </>
            }
            path="/joinus"
          />

          <Route
            element={
              <>
                {" "}
                {/* <Header /> */}
                <Navbar />
                <About />
                <Whatsapp />
                <Footer />
              </>
            }
            path="/about"
          />

          <Route path="/receipt/:id" element={<Receipt />} />

          <Route
            element={
              <>
                {" "}
                {/* <Header /> */}
                <Navbar />
                <OurEvent />
                <Whatsapp />
                <Footer />
              </>
            }
            path="/recent"
          />

          <Route
            element={
              <>
                {" "}
                {/* <Header /> */}
                <Navbar />
                <CommunityOutReach />
                <Whatsapp />
                <Footer />
              </>
            }
            path="/outreach"
          />

          <Route
            element={
              <>
                <Navbar />
                <DonateUs />
                <Whatsapp />
                <Footer />
              </>
            }
            path="/donateus"
          />

          <Route
            element={
              <>
                {" "}
                {/* <Header /> */}
                <Navbar />
                <StudyandResearchcenter />
                <Whatsapp />
                <Footer />
              </>
            }
            path="/study&researchcenter"
          />

          <Route
            element={
              <>
                {" "}
                {/* <Header /> */}
                <Navbar />
                <Gallery />
                <Whatsapp />
                <Footer />
              </>
            }
            path="/gallery"
          />
          <Route
            path="/payment-success"
            element={
              <>
                <PaymentSuccess />
              </>
            }
          />
          <Route
            element={
              <>
                {/* <Header /> */}
                <Navbar />
                <Contact />
                <Whatsapp />
                <Footer />
              </>
            }
            path="/contact"
          />

          <Route
            element={
              <>
                {/* <Header /> */}
                <Navbar />
                <DetailsNews />
                <Whatsapp />
                <Footer />
              </>
            }
            path="/detailsnews"
          />

          <Route
            element={
              <>
                {/* <Header /> */}
                <Navbar />
                <RecentNews />
                <Whatsapp />
                <Footer />
              </>
            }
            path="/recent/:id"
          />

          <Route
            element={
              <>
                {/* <Header /> */}
                <Navbar />
                <MostPopularNewsDetails />
                <Whatsapp />
                <Footer />
              </>
            }
            path="/mostpopularnews/:id"
          />

          <Route
            element={
              <>
                <Navbar />
                <CampaignPage />
                <Whatsapp />
                <Footer />
              </>
            }
            path="/campaign"
          />

          <Route
            element={
              <>
                {" "}
                {/* <Header /> */}
                <Navbar />
                <MostpopulerDetails />
                <Whatsapp />
                <Footer />
              </>
            }
            path="/mostpopulerdetails"
          />

          <Route
            element={
              <>
                {" "}
                {/* <Header /> */}
                <Navbar />
                <CommunityOutreachDetails />
                <Whatsapp />
                <Footer />
              </>
            }
            path="/outreach/:id"
          />

          <Route
            element={
              <>
                {" "}
                {/* <Header /> */}
                <Navbar />
                <StudyandResearchDetails />
                <Whatsapp />
                <Footer />
              </>
            }
            path="/study&research/:id"
          />

          <Route
            element={
              <>
                {/* <Header /> */}
                <Navbar />
                <CampaignDetails />
                <Whatsapp />
                <Footer />
              </>
            }
            path="/campaigndetails"
          />

          <Route
            element={
              <>
                {/* <Header /> */}
                <Navbar />
                <CampaignDetails />
                <Whatsapp />
                <Footer />
              </>
            }
            path="/campaign/:id"
          />

          <Route
            element={
              <>
                <Termsandconditions />
              </>
            }
            path="/termsandconditions"
          />

          <Route
            element={
              <>
                <Privacypolicy />
              </>
            }
            path="/privacypolicy"
          />

          <Route exact path="/admin" element={<AdminLogin />} />

          <Route
            exact
            path="/dashboard"
            element={<AdminHeader children={<DashBoard />} />}
          />

          <Route
            exact
            path="/adminlatestnews"
            element={<AdminHeader children={<LatestNews />} />}
          />

          <Route
            exact
            path="/mostpopularnews"
            element={<AdminHeader children={<MostPopularNews />} />}
          />

          <Route
            exact
            path="/admincommunityoutreach"
            element={<AdminHeader children={<CommunityOutreach />} />}
          />

          <Route
            exact
            path="/adminstudyresearchcenter"
            element={<AdminHeader children={<StudyResearchCenter />} />}
          />

          <Route
            exact
            path="/campaignAdmin"
            element={<AdminHeader children={<Campaign />} />}
          />

          <Route
            exact
            path="/innews"
            element={<AdminHeader children={<InNews />} />}
          />

          <Route
            exact
            path="/galleryadmin"
            element={<AdminHeader children={<GalleryAdmin />} />}
          />

          <Route
            exact
            path="/aboutusadmin"
            element={<AdminHeader children={<AboutusAdmin />} />}
          />

          <Route
            exact
            path="/admincontactus"
            element={<AdminHeader children={<ContactUsAdmin />} />}
          />

          <Route
            exact
            path="/membershiplist"
            element={<AdminHeader children={<MembershipList />} />}
          />

          <Route
            exact
            path="/donorlist"
            element={<AdminHeader children={<DonorList />} />}
          />

          <Route
            exact
            path="/socialmediallinks"
            element={<AdminHeader children={<SocialMedialLinks />} />}
          />

          <Route
            exact
            path="/contactdetails"
            element={<AdminHeader children={<ContactDetails />} />}
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default App;
